import { render } from "./SavePost.vue?vue&type=template&id=180f581c"
import script from "./SavePost.vue?vue&type=script&lang=js"
export * from "./SavePost.vue?vue&type=script&lang=js"

import "./SavePost.vue?vue&type=style&index=0&id=180f581c&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__